import { Nullable } from 'global';
import { AftermarketProductQualifiedEventOptions } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/product-qualified/aftermarket-product-qualified-event-options';

export function collectMinMaxPriceConfiguration(
  event?: AftermarketProductQualifiedEventOptions,
  retailCost?: number
): {
  minRetailCost: number | null;
  maxRetailCost: number | null;
  isMinMaxRetailCostValid: boolean;
} {
  const minRetailCost = Number(event?.params?.PRICING_MIN) || null;
  const maxRetailCost = Number(event?.params?.PRICING_MAX) || null;

  const isMinMaxRetailCostValid = retailCost
    ? checkIfMinMaxPricingValid(minRetailCost, maxRetailCost, retailCost)
    : true;

  return {
    minRetailCost,
    maxRetailCost,
    isMinMaxRetailCostValid,
  };
}

export function checkIfMinMaxPricingValid(
  minRetailCost: Nullable<number>,
  maxRetailCost: Nullable<number>,
  retailCost: number
) {
  if (minRetailCost && retailCost < minRetailCost) {
    return false;
  }
  if (maxRetailCost && retailCost > maxRetailCost) {
    return false;
  }
  return true;
}
